import { render, staticRenderFns } from "./english-big-test.vue?vue&type=template&id=510e1460&scoped=true&"
import script from "./english-big-test.vue?vue&type=script&lang=js&"
export * from "./english-big-test.vue?vue&type=script&lang=js&"
import style0 from "./english-big-test.vue?vue&type=style&index=0&id=510e1460&lang=scss&scoped=true&"
import style1 from "./english-big-test.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510e1460",
  null
  
)

export default component.exports